/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ day: NonNullable<unknown> }} Today_Day_DoneInputs */

const en_us2_today_day_done = /** @type {(inputs: Today_Day_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} · Workout done`)
};

const pt_br2_today_day_done = /** @type {(inputs: Today_Day_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} · Treino feito`)
};

const es_419_today_day_done = /** @type {(inputs: Today_Day_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} · Entrenamiento hecho`)
};

const pt_pt2_today_day_done = /** @type {(inputs: Today_Day_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} · Treino feito`)
};

const fr_fr2_today_day_done = /** @type {(inputs: Today_Day_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} · Séance faite`)
};

const de_de2_today_day_done = /** @type {(inputs: Today_Day_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} · Training erledigt`)
};

const it_it2_today_day_done = /** @type {(inputs: Today_Day_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} · Allenamento fatto`)
};

/**
* | output |
* | --- |
* | "{day} · Workout done" |
*
* @param {Today_Day_DoneInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_day_done = /** @type {((inputs: Today_Day_DoneInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Day_DoneInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_day_done(inputs)
	if (locale === "es-419") return es_419_today_day_done(inputs)
	if (locale === "pt-PT") return pt_pt2_today_day_done(inputs)
	if (locale === "fr-FR") return fr_fr2_today_day_done(inputs)
	if (locale === "de-DE") return de_de2_today_day_done(inputs)
	if (locale === "it-IT") return it_it2_today_day_done(inputs)
	return en_us2_today_day_done(inputs)
});
export { today_day_done as "today.day_done" }